<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
  >
    <v-card>
      <v-card-title>Şube ve Depo Seçimi</v-card-title>

      <v-card-text>
        <div class="py-4">
          <v-select
              v-model="userBranchCodeVal"
              label="Şube"
              placeholder="Şube Seçiniz"
              clearable
              filled
              dense
              solo
              :items="branchList"
              :item-text="item => item.name"
              :item-value="item => item.code"
              @change="getWarehouseList"
          >
          </v-select>
          <v-select
              v-model="userWarehouseCodeVal"
              label="Depo"
              placeholder="Depo Seçiniz"
              clearable
              filled
              dense
              solo
              :items="erpWarehouseList"
              :item-text="item => item.name"
              :item-value="item => item.code"
          >
          </v-select>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red darken-2" @click="dialog = false">İptal</v-btn>
        <v-btn text color="success darken-2" @click="updateUserBranchWarehouse()"
               :disabled="userBranchCodeVal !== -1 && (userWarehouseCodeVal === null || userWarehouseCodeVal === -1)">
          Kaydet
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations} from "vuex";

export default {
  name: "UserBranchWarehouseDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("auth", ['user']),
    ...mapState("company", ['branchList',"erpWarehouseList"]),
  },
  data() {
    return {
      userBranchCodeVal: null,
      userWarehouseCodeVal: null,
      dialog: false
    }
  },
  methods: {
    ...mapActions("auth", ["getLoggedUser"]),
    ...mapActions("user", ["userBranchWarehouseUpdate"]),
    ...mapActions("company", ['fetchBranchList',"fetchErpWarehouseList"]),
    ...mapMutations("company", ['setBranchList',"setErpWarehouseList"]),
    async getBranchList() {
      await this.fetchBranchList({
        params: {},
        body: {}
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({code: -1, name: 'Tüm Şubeler'})
      this.setBranchList(tempBranchList);
    },
    async getWarehouseList() {
      await this.fetchErpWarehouseList({
        params: {
          branchCode: this.userBranchCodeVal
        },
        body: {}
      });
      let tempWarehouseList = this.warehouseList.slice();
      tempWarehouseList.unshift({code: -1, name: 'Depo Seçin'})
      this.setErpWarehouseList(tempWarehouseList);
    },
    async updateUserBranchWarehouse() {
      let result = await this.userBranchWarehouseUpdate({
        params: {
          userId: this.user.UserId,
          branchCode: this.userBranchCodeVal,
          ...(!(this.branchCode === "" || this.branchCode === null || this.branchCode === -1)) && {warehouseCode: this.userWarehouseCodeVal},

        },
        body: {}
      });
      if (result.data.success) {
        this.dialog = false;
        await this.getLoggedUser({
          params: {},
          body: {},
          urlSegments: [this.user.UserId]
        });
      }


    }
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal) {
        this.getBranchList();
        this.userBranchCodeVal = this.user.userInfo.branchCode;
        this.userWarehouseCodeVal = this.user.userInfo.warehouseCode;
        this.getWarehouseList();
      }
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>